import { AgentNoticeKind, } from '@debbie/common/dist/agents/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import IconButton from '../IconButton.js';
import X from '../Icons/X.js';
import Loading from '../Loading.js';
const Card = styled.div `
  padding: ${THEME.GRID_SPACING}px 0;
  border-top: 1px solid ${THEME.BORDER};

  &:first-child {
    border-top: none;
    padding-top: 0;
  }
`;
const Header = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`;
const Title = styled.strong `
  color: ${THEME.COLOR_PRIMARY};
`;
const Time = styled.span `
  color: ${THEME.COLOR_GREY};
  font-size: 0.8em;
  flex: 1;
`;
const Summary = styled.div `
  white-space: pre-wrap;
  line-height: 1.45;
`;
const DismissButton = styled(IconButton) `
  flex: 0 0 auto;

  &:disabled {
    opacity: 0.5;
    cursor: ${(p) => (p.$loading ? 'progress' : 'not-allowed')};
  }
`;
const AgentNoticeCard = ({ notice, loading, disabled = false, onDismiss }) => {
    const lang = useSelector((s) => s.lang);
    const human = notice.kind === AgentNoticeKind.HumanEscalation;
    return (React.createElement(Card, null,
        React.createElement(Header, null,
            React.createElement(Title, null, human
                ? lang.agentNotices.humanEscalation
                : lang.agentNotices.systemFailure),
            React.createElement(Time, { title: moment(notice.createdAt).format('LLL') }, moment(notice.createdAt).fromNow()),
            React.createElement(DismissButton, { type: "button", title: lang.agentProposals.dismiss, "aria-label": lang.agentProposals.dismiss, disabled: disabled || loading, $loading: loading, onClick: onDismiss }, loading ? React.createElement(Loading, { width: "18px" }) : React.createElement(X, { size: "18px" }))),
        React.createElement(Summary, null, notice.summary)));
};
export default AgentNoticeCard;
//# sourceMappingURL=AgentNoticeCard.js.map